export default "__VITE_ASSET__BXH1uhWj__"